import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ActionButtonComponent } from 'app/Components/action-button/action-button.component';
import { GreenActionButtonComponent } from 'app/Components/green-action-button/green-action-button.component';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
    selector: 'app-customer-not-found-page',
    host: {
        class: 'w-full h-full block',
    },
    imports: [LottieComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <div
      class="w-full h-full flex flex-col justify-center items-center bg-gris-4 px-12"
    >
      <ng-lottie [options]="options" class="w-80" />

      <div
        class="bg-white rounded p-2 w-80 md:w-96 h-fit border border-gris-3 flex flex-col"
      >
        <p class="w-full text-center bg-orange-1 rounded p-2 flex items-center">
          <span class="text-white text-4xl material-icons"> error </span>
          <span class="text-white font-semibold text-center flex-1">
            Aucun client trouvé...
          </span>

        </p>

        <p class="my-4 text-center font-medium">
          Aucun site n'a été trouvé pour le domaine <span class="font-bold fg-vert-1">{{this.domain}}</span>.
        </p>
      </div>
    </div>
  `
})
export class CustomerNotFoundPageComponent {
  private router = inject(Router);

  options: AnimationOptions = {
    path: '/assets/lottie/not-found.json',
  };

  domain: string = "";

  ngOnInit() {
    this.domain = window.location.hostname.split('.')[0];
  }

  returnToIndex() {
    this.router.navigate(['/']);
  }
}
